// Import the ExcelJS library for reading Excel files
import ExcelJS from "exceljs";
// Import UUID utilities
import { v1 as uuidv1 } from "uuid";
// Import header and row validation function
import { validateExcelHeaders } from "../validation/validateExcelHeaders";
import { validateExcelRows } from "../validation/validateExcelRows";

export async function extractExcelData(file, setErrors) {
  // Create a new workbook instance
  const workbook = new ExcelJS.Workbook();
  // Initialize variable to hold processed item data
  let itemData;
  // Array to hold the rows of data extracted from the Excel file
  const jsonData = [];

  // Load the Excel file into the workbook
  await workbook.xlsx.load(file.file).then(() => {
    // Get the first worksheet
    const worksheet = workbook.getWorksheet(1);

    // Validate the headers (in the first row) of the worksheet
    const { validationErrorsHeader, areHeadersValid } = validateExcelHeaders(
      worksheet.getRow(1)
    );
    // Throw an error if headers are invalid
    if (!areHeadersValid) throw validationErrorsHeader;

    // If headers are valid, iterate through each row of the worksheet
    areHeadersValid &&
      worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
        // Array to hold the current row's data
        const rowData = [];
        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          // Add cell value to rowData array
          rowData.push(cell.value);
        });
        // Push the row data to jsonData array
        jsonData.push(rowData);
      });

    // Validate the extracted rows of data
    const { validationErrorsRows, areRowsValid } = validateExcelRows(jsonData);
    if (!areRowsValid) {
      // Clear jsonData if rows are invalid
      jsonData.length = 0;
      // Throw an error if rows are invalid
      throw validationErrorsRows;
    }

    // If rows are valid, create structured item data
    itemData = createItemData(jsonData, areRowsValid);
  });
  // Return the structured item data
  return itemData;
}

// Function to create structured item data from jsonData
function createItemData(jsonData, areRowsValid) {
  // Array to hold structured item objects
  const items = [];
  if (areRowsValid) {
    // Only process rows if they are valid
    jsonData.slice(1).forEach((row) => {
      items.push({
        sampleItemID: `SI-ID-${uuidv1()}`,
        itemERPCode: row[0] ? row[0].replace(/ /g, "") : "N/A", //removes any leading, trailing or in-between spaces in the string
        itemDescription: row[1],
        specification: row[2],
        quantityForSample: row[3],
        preferredUnitOfMeasure: row[4],
        productClass: row[5],
        productImage: [],
      });
    });
  }
  // Only process rows if they are valid
  return items;
}
